/**
 * @description for use in utils & functions to truncate long strings
 * @example Long str…
 */
export const OMISSION_STRING = '…';
